<template>
    <div>
        <div class="nav-vertical">
			<ul class="nav nav-tabs nav-left" role="tablist">
                <li class="nav-item">
                  <a class="nav-link active" v-bind:href="'#t1'+rowData.pedido_id+''" role="tab" data-toggle="tab" >
                    <span class="nav-link-in">
                      Detalhes
                      <i class="fa fa-plus"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t2'+rowData.pedido_id+''" v-if="rowData.pedido_param_trecho.length>0" role="tab" data-toggle="tab" >
                    <span class="nav-link-in">
                      Trecho
                      <i class="fa fa-road"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t3'+rowData.pedido_id+''" v-if="rowData.pedido_param_comp_frete.length>0" role="tab" data-toggle="tab" >
                    <span class="nav-link-in">
                      Componente de Frete
                      <i class="fa fa-truck"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t4'+rowData.pedido_id+''" v-if="rowData.pedido_unidade_carga.length>0" role="tab" data-toggle="tab" >
                    <span class="nav-link-in">
                      Unidade de carga
                      <i class="fa fa-ship"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t5'+rowData.pedido_id+''" v-if="rowData.pedido_param_seguro.length>0" role="tab" data-toggle="tab" >
                    <span class="nav-link-in">
                      Seguro
                      <i class="fa fa-shield"></i>
                    </span>
                  </a>
                </li>
			</ul>

                <div class="tab-content">
                    <div role="tabpanel" class="tab-pane fade in active show pt-1 border-color-detalhes-grey" v-bind:id="'t1'+rowData.pedido_id+''">
                      <table class="table-striped" id="mais">
                          <thead>
                              <tr>
                                  <th style="width: 15%">CFOP</th>
                                  <th style="width: 15%">CST</th>
                                  <th style="width: 15%">Municipio de Início</th>
                                  <th style="width: 15%">Municipio de Fim</th>
                                  <th style="width: 10%">Tipo Pedido</th>
                                  <th style="width: 10%">Tipo Serviço</th>
                                  <th style="width: 10%">Tipo Carga</th>
                                  <th style="width: 10%">Tipo Fronteira</th>
                              </tr>
                           </thead>
                           <tbody>
                               <tr class="bg-gray-light" style="display: table-row;">
                                  <td>
                                      <span v-if="rowData.cfop!==null">{{ rowData.cfop.descr }}</span>
                                  </td>
                                  <td>
                                      <span v-if="rowData.param_cst!==null">
                                      {{ rowData.param_cst.cd }} - {{ rowData.param_cst.descr }}
                                      </span>
                                  </td>
                                  <td>
                                      {{ rowData.municipio_inicio.nome }}
                                  </td>
                                  <td>
                                      {{ rowData.municipio_fim.nome }}
                                  </td>
                                  <td>
                                      {{ rowData.tp_pedido.descr }}
                                  </td>
                                  <td>
                                      {{ rowData.tp_servico.descr }}
                                  </td>
                                  <td>
                                      {{ rowData.tp_carga.descr }}
                                  </td>
                                  <td>
                                      {{ rowData.tp_fronteira.descr }}
                                  </td>
                              </tr>
                          </tbody>
                      </table>
                      <table class="table-striped" id="mais">
                          <thead>
                              <tr>
                                  <th style="width: 20%">Produto Predominante</th>
                                  <th style="width: 20%">Tomador CTE</th>
                                  <th style="width: 10%">Modal</th>
                                  <th style="width: 5%">Valor Carga</th>
                                  <th style="width: 5%">Valor Advalorem</th>
                                  <th style="width: 5%">Exibe ADValorem CFrete</th>
                                  <th style="width: 5%">Permite Adicionar UC</th>
                                  <th style="width: 5%">Imposto Incluso</th>
                                  <th style="width: 5%">% Advalorem</th>
                              </tr>
                           </thead>
                           <tbody>
                               <tr class="bg-gray-light" style="display: table-row;">
                                  <td>
                                      {{ rowData.produto_predominante }}
                                  </td>
                                  <td>
                                      <span v-if="rowData.pedido_tomador.descr">
                                          {{ rowData.pedido_tomador.descr }}
                                      </span>
                                  </td>
                                  <td>
                                      {{ rowData.b_modal.descr }}
                                  </td>
                                  <td>
                                      {{ rowData.tp_valor_carga.descr }}
                                  </td>
                                  <td>
                                      {{ rowData.tp_valor_advalorem.descr }}
                                  </td>
                                  <td>
                                      <span class="badge badge-success" v-if="rowData.exibe_advalorem_c_frete.valor==1">{{ rowData.exibe_advalorem_c_frete.descr }}</span>
                                      <span class="badge badge-danger" v-if="rowData.exibe_advalorem_c_frete.valor==2">{{ rowData.exibe_advalorem_c_frete.descr }}</span>
                                  </td>
                                  <td>
                                      <span class="badge badge-success" v-if="rowData.permite_adicionar_uc.valor==1">{{ rowData.permite_adicionar_uc.descr }}</span>
                                      <span class="badge badge-danger" v-if="rowData.permite_adicionar_uc.valor==2">{{ rowData.permite_adicionar_uc.descr }}</span>
                                  </td>
                                  <td>
                                    <span class="badge badge-success" v-if="rowData.imposto_incluso.valor==1">{{ rowData.imposto_incluso.descr }}</span>
                                    <span class="badge badge-danger" v-if="rowData.imposto_incluso.valor==2">{{ rowData.imposto_incluso.descr }}</span>
                                  </td>
                                  <td>
                                      {{ rowData.percentual_advalorem }} %
                                  </td>
                              </tr>
                          </tbody>
                      </table>
                      <table class="table-striped" id="mais">
                          <thead>
                              <tr>
                                  <th v-if="rowData.obs!==null"style="width: 33%">Observação Pedido</th>
                                  <th v-if="rowData.obs_cte!==null"style="width: 33%">Observação CTE</th>
                                  <th v-if="rowData.obs_cte_fiscal!==null"style="width: 33%">Observação CTE Fiscal</th>
                              </tr>
                           </thead>
                           <tbody>
                               <tr class="bg-gray-light" style="display: table-row;">
                                   <td v-if="rowData.obs!==null">
                                       {{ rowData.obs }}
                                   </td>
                                  <td v-if="rowData.obs_cte!==null">
                                      {{ rowData.obs_cte }}
                                  </td>
                                  <td v-if="rowData.obs_cte_fiscal!==null">
                                      {{ rowData.obs_cte_fiscal }}
                                  </td>
                              </tr>
                          </tbody>
                      </table>
              </div><!--.tab-pane-->
                <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey" v-bind:id="'t2'+rowData.pedido_id+''">
                        <table class="table-striped" id="mais">
                            <thead>
                                <tr>
                                    <th style="width: 5%">Ordem/Principal</th>
                                    <th style="width: 10%">Tipo Trecho</th>
                                    <th style="width: 15%">Tipo Custo</th>
                                    <th style="width: 15%">Modal</th>
                                    <th style="width: 13%">Município Início</th>
                                    <th style="width: 12%">Municipio Fim</th>
                                    <th style="width: 15%">Fornecedor</th>
                                    <th style="width: 5%">Status</th>
                                    <th style="width: 5%">Ações</th>
                                </tr>
                             </thead>
                             <tbody>
                               <template v-for="item in rowData.pedido_param_trecho">
                                 <tr class="bg-gray-light" style="display: table-row;">
                                    <td>
                                        {{ item.ordem }} - <span class="badge badge-success" v-if="item.principal.valor==1">{{ item.principal.descr }}</span>
                                                           <span class="badge badge-danger" v-if="item.principal.valor==2">{{ item.principal.descr }}</span>
                                    </td>
                                    <td>
                                        {{ item.tp_trecho.descr }}
                                    </td>
                                    <td>
                                      <span class="badge badge-success" v-if="item.tp_custo.valor==1">{{ item.tp_custo.descr }}</span>
                                      <span class="badge badge-danger" v-if="item.tp_custo.valor==2">{{ item.tp_custo.descr }}</span>
                                    </td>
                                    <td>
                                        {{ item.b_modal.descr }}
                                    </td>
                                    <td>
                                        {{ item.municipio_inicio.nome }}
                                    </td>
                                    <td>
                                        {{ item.municipio_fim.nome }}
                                    </td>
                                    <td>
                                        <span v-if="item.fornecedor!==null && item.fornecedor.pessoa_juridica!==null">{{ onFormataCnpj(item.fornecedor.pessoa_juridica.cnpj_base,item.fornecedor.pessoa_juridica.cnpj_filial,item.fornecedor.pessoa_juridica.cnpj_digito)}} - {{ item.fornecedor.pessoa_juridica.razao_social }}</span>
                                        <span v-if="item.fornecedor!==null && item.fornecedor.pessoa_fisica!==null">{{ item.fornecedor.pessoa_fisica.nome }} - {{ item.fornecedor.pessoa_fisica.cpf }}</span>
                                        <span v-if="item.fornecedor!==null && item.fornecedor.pessoa_exterior!==null">{{ item.fornecedor.pessoa_exterior.nome }} - {{ item.fornecedor.pessoa_exterior.cuit }}</span>
                                    </td>
                                    <td>
                                        {{ item.municipio_fim.nome }}
                                    </td>
                                    <td>
                                      <span class="badge badge-success" v-if="item.status.valor==1">{{ item.status.descr }}</span>
                                      <span class="badge badge-danger" v-if="item.status.valor==2">{{ item.status.descr }}</span>
                                    </td>
                                    <td>
                                      <a @click="onDetailTrecho(item)" v-if="item.pedido_param_trecho_custo.length>0" v-b-tooltip title="Ver detalhes"><i class="fa fa-plus"></i></a>
                                    </td>
                                </tr>
                                <tr v-if="isVisibleDetailRow(item.pedpartrc_id)">
                                    <td colspan="9">
                                      <section class="tabs-section">
                                      <div class="tabs-section-nav">
                                        <div class="tbl">
                                          <ul class="nav" role="tablist">
                                            <li class="nav-item">
                                              <a class="nav-link active" v-bind:href="'#t1'+item.pedpartrc_id+''" role="tab" data-toggle="tab" >
                                                <span class="nav-link-in">
                                                  Custos do Trecho
                                                  <i class="fa fa-bulding"></i>
                                                </span>
                                              </a>
                                            </li>
                                          </ul>
                                        </div>
                                      </div><!--.tabs-section-nav-->
                                      <div class="tab-content">
                                      <div role="tabpanel" class="tab-pane fade in active show pt-1 border-color-detalhes-grey" v-bind:id="'t1'+item.pedpartrc_id+''">
                                        <table :class="['vuetable table table-striped tbl-typical']">
                                        <thead>
                                          <tr>
                                              <th style="width: 20%">Descrição</th>
                                              <th style="width: 20%">Tipo Custo</th>
                                              <th style="width: 20%">Custo</th>
                                              <th style="width: 20%">Valor</th>
                                              <th style="width: 20%">Status</th>
                                          </tr>
                                          </thead>
                                          <tbody  v-for="item_trecho_custo in item.pedido_param_trecho_custo">
                                              <tr class="bg-gray-light" style="display: table-row;">
                                                 <td>
                                                     <span v-if="item_trecho_custo.descr!==null">{{ item_trecho_custo.descr }}</span>
                                                 </td>
                                                 <td>
                                                     <span v-if="item_trecho_custo.tp_custo.descr!==null">{{ item_trecho_custo.tp_custo.descr }}</span>
                                                 </td>
                                                 <td>
                                                     <span v-if="item_trecho_custo.custo.descr!==null">{{ item_trecho_custo.custo.descr }}</span>
                                                 </td>
                                                 <td>
                                                     <span v-if="item_trecho_custo.vlr_custo!==null">{{ item_trecho_custo.vlr_custo }}</span>
                                                 </td>
                                                 <td>
                                                   <span class="badge badge-success" v-if="item_trecho_custo.status.valor==1">{{ item_trecho_custo.status.descr }}</span>
                                                   <span class="badge badge-danger" v-if="item_trecho_custo.status.valor==2">{{ item_trecho_custo.status.descr }}</span>
                                                 </td>
                                             </tr>
                                           </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </section>
                                </td>
                              </tr>
                              </template>
                               <template v-for="item in rowData.pedido_param_trecho_receita">
                                 <tr class="bg-gray-light" style="display: table-row;">
                                   <td>
                                     {{ item.ordem }} - <span class="badge badge-success" v-if="item.principal.valor==1">{{ item.principal.descr }}</span>
                                     <span class="badge badge-danger" v-if="item.principal.valor==2">{{ item.principal.descr }}</span>
                                   </td>
                                   <td>
                                     {{ item.tp_trecho.descr }}
                                   </td>
                                   <td>
                                     <span class="badge badge-success" v-if="item.tp_custo.valor==1">{{ item.tp_custo.descr }}</span>
                                     <span class="badge badge-danger" v-if="item.tp_custo.valor==2">{{ item.tp_custo.descr }}</span>
                                   </td>
                                   <td>
                                     {{ item.b_modal.descr }}
                                   </td>
                                   <td>
                                     {{ item.municipio_inicio.nome }}
                                   </td>
                                   <td>
                                     {{ item.municipio_fim.nome }}
                                   </td>
                                   <td>
                                     <span v-if="item.fornecedor!==null && item.fornecedor.pessoa_juridica!==null">{{ onFormataCnpj(item.fornecedor.pessoa_juridica.cnpj_base,item.fornecedor.pessoa_juridica.cnpj_filial,item.fornecedor.pessoa_juridica.cnpj_digito)}} - {{ item.fornecedor.pessoa_juridica.razao_social }}</span>
                                     <span v-if="item.fornecedor!==null && item.fornecedor.pessoa_fisica!==null">{{ item.fornecedor.pessoa_fisica.nome }} - {{ item.fornecedor.pessoa_fisica.cpf }}</span>
                                     <span v-if="item.fornecedor!==null && item.fornecedor.pessoa_exterior!==null">{{ item.fornecedor.pessoa_exterior.nome }} - {{ item.fornecedor.pessoa_exterior.cuit }}</span>
                                   </td>
                                   <td>
                                     <span class="badge badge-success" v-if="item.status.valor==1">{{ item.status.descr }}</span>
                                     <span class="badge badge-danger" v-if="item.status.valor==2">{{ item.status.descr }}</span>
                                   </td>
                                   <td>
                                     <a @click="onDetailTrecho(item)" v-if="item.pedido_param_trecho_custo.length>0" v-b-tooltip title="Ver detalhes"><i class="fa fa-plus"></i></a>
                                   </td>
                                 </tr>
                                 <tr v-if="isVisibleDetailRow(item.pedpartrc_id)">
                                   <td colspan="9">
                                     <section class="tabs-section">
                                       <div class="tabs-section-nav">
                                         <div class="tbl">
                                           <ul class="nav" role="tablist">
                                             <li class="nav-item">
                                               <a class="nav-link active" v-bind:href="'#t1'+item.pedpartrc_id+''" role="tab" data-toggle="tab" >
                                                <span class="nav-link-in">
                                                  Custos do Trecho
                                                  <i class="fa fa-bulding"></i>
                                                </span>
                                               </a>
                                             </li>
                                           </ul>
                                         </div>
                                       </div><!--.tabs-section-nav-->
                                       <div class="tab-content">
                                         <div role="tabpanel" class="tab-pane fade in active show pt-1 border-color-detalhes-grey" v-bind:id="'t1'+item.pedpartrc_id+''">
                                           <table :class="['vuetable table table-striped tbl-typical']">
                                             <thead>
                                             <tr>
                                               <th style="width: 20%">Descrição</th>
                                               <th style="width: 20%">Tipo Custo</th>
                                               <th style="width: 20%">Custo</th>
                                               <th style="width: 20%">Valor</th>
                                               <th style="width: 20%">Status</th>
                                             </tr>
                                             </thead>
                                             <tbody  v-for="item_trecho_custo in item.pedido_param_trecho_custo">
                                             <tr class="bg-gray-light" style="display: table-row;">
                                               <td>
                                                 <span v-if="item_trecho_custo.descr!==null">{{ item_trecho_custo.descr }}</span>
                                               </td>
                                               <td>
                                                 <span v-if="item_trecho_custo.tp_custo.descr!==null">{{ item_trecho_custo.tp_custo.descr }}</span>
                                               </td>
                                               <td>
                                                 <span v-if="item_trecho_custo.custo.descr!==null">{{ item_trecho_custo.custo.descr }}</span>
                                               </td>
                                               <td>
                                                 <span v-if="item_trecho_custo.vlr_custo!==null">{{ item_trecho_custo.vlr_custo }}</span>
                                               </td>
                                               <td>
                                                 <span class="badge badge-success" v-if="item_trecho_custo.status.valor==1">{{ item_trecho_custo.status.descr }}</span>
                                                 <span class="badge badge-danger" v-if="item_trecho_custo.status.valor==2">{{ item_trecho_custo.status.descr }}</span>
                                               </td>
                                             </tr>
                                             </tbody>
                                           </table>
                                         </div>
                                       </div>
                                     </section>
                                   </td>
                                 </tr>
                               </template>
                            </tbody>
                        </table>
                </div><!--.tab-pane-->
                <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey" v-bind:id="'t3'+rowData.pedido_id+''">
                                <table class="table-striped" id="mais">
                                    <thead>
                                        <tr>
                                            <th style="width: 50%">Custo</th>
                                            <th style="width: 30%">Insere Advalorem</th>
                                            <th style="width: 20%">Valor</th>
                                        </tr>
                                     </thead>
                                     <tbody>
                                         <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.pedido_param_comp_frete">
                                            <td>
                                                {{ item.custo.descr }}
                                            </td>
                                            <td>
                                              <span class="badge badge-success" v-if="item.insere_advalorem.valor==1">{{ item.insere_advalorem.descr }}</span>
                                              <span class="badge badge-danger" v-if="item.insere_advalorem.valor==2">{{ item.insere_advalorem.descr }}</span>
                                            </td>
                                            <td>
                                                {{ item.vlr }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                        </div><!--.tab-pane-->
                        <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey" v-bind:id="'t4'+rowData.pedido_id+''">
                                        <table class="table-striped" id="mais">
                                            <thead>
                                                <tr>
                                                    <th style="width: 70%">N° UC</th>
                                                    <th style="width: 20%">Status</th>
                                                    <th style="width: 10%">Ações</th>
                                                </tr>
                                             </thead>
                                             <tbody>
                                               <template v-for="item_uc in rowData.pedido_unidade_carga">
                                                 <tr class="bg-gray-light" style="display: table-row;">
                                                    <td>
                                                        {{ item_uc.num_uc }}
                                                    </td>
                                                    <td>
                                                      <span class="badge badge-primary" v-if="item_uc.status.valor==1">{{ item_uc.status.descr }}</span>
                                                      <span class="badge badge-warning" v-if="item_uc.status.valor==2">{{ item_uc.status.descr }}</span>
                                                      <span class="badge badge-success" v-if="item_uc.status.valor==3">{{ item_uc.status.descr }}</span>
                                                      <span class="badge badge-danger" v-if="item_uc.status.valor==4">{{ item_uc.status.descr }}</span>
                                                    </td>
                                                    <td>
                                                      <a @click="onDetailUnidadeCargaTrecho(item_uc.pedunicar_id)" v-if="item_uc.pedido_unidade_carga_trecho.length>0" v-b-tooltip title="Ver detalhes"><i class="fa fa-plus"></i></a>
                                                    </td>
                                                </tr>
                                                <tr v-if="isVisibleDetailRowPedido(item_uc.pedunicar_id)">
                                                    <td colspan="9">
                                                      <section class="tabs-section">
                                                      <div class="tabs-section-nav">
                                                        <div class="tbl">
                                                          <ul class="nav" role="tablist">
                                                            <li class="nav-item">
                                                              <a class="nav-link active" v-bind:href="'#t2'+item_uc.pedunicar_id+''" role="tab" data-toggle="tab" >
                                                                <span class="nav-link-in">
                                                                  Trechos
                                                                  <i class="fa fa-bulding"></i>
                                                                </span>
                                                              </a>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div><!--.tabs-section-nav-->
                                                      <div class="tab-content">
                                                      <div role="tabpanel" class="tab-pane fade in active show pt-1 border-color-detalhes-grey" v-bind:id="'t2'+item_uc.pedunicar_id+''">
                                                        <table :class="['vuetable table table-striped tbl-typical']">
                                                        <thead>
                                                          <tr>
                                                              <th style="width: 10%">Nº Trecho</th>
                                                              <th style="width: 5%">Ordem/Principal</th>
                                                              <th style="width: 5%">Tipo Trecho</th>
                                                              <th style="width: 10%">Tipo Custo</th>
                                                              <th style="width: 15%">Modal</th>
                                                              <th style="width: 13%">Município Início</th>
                                                              <th style="width: 12%">Municipio Fim</th>
                                                              <th style="width: 15%">Fornecedor</th>
                                                              <th style="width: 15%">Código tabela de frete</th>
                                                              <th style="width: 15%">Tabela de frete</th>
                                                              <th style="width: 5%">Status</th>
                                                              <th style="width: 5%">Ações</th>
                                                          </tr>
                                                          </thead>
                                                          <tbody  v-for="item_trecho in item_uc.pedido_unidade_carga_trecho">
                                                              <tr class="bg-gray-light" style="display: table-row;">
                                                                 <td v-if="item_trecho.num_trecho!==null">
                                                                     {{ item_trecho.num_trecho }}
                                                                 </td>
                                                                 <td v-if="item_trecho.ordem!==null">
                                                                     {{ item_trecho.ordem }} - <span class="badge badge-success" v-if="item_trecho.principal.valor==1">{{ item_trecho.principal.descr }}</span>
                                                                                                     <span class="badge badge-danger" v-if="item_trecho.principal.valor==2">{{ item_trecho.principal.descr }}</span>
                                                                 </td>
                                                                 <td>
                                                                     {{ item_trecho.tp_trecho.descr }}
                                                                 </td>
                                                                 <td>
                                                                   <span class="badge badge-success" v-if="item_trecho.tp_custo.valor==1">{{ item_trecho.tp_custo.descr }}</span>
                                                                   <span class="badge badge-danger" v-if="item_trecho.tp_custo.valor==2">{{ item_trecho.tp_custo.descr }}</span>
                                                                 </td>
                                                                 <td>
                                                                     {{ item_trecho.b_modal.descr }}
                                                                 </td>
                                                                 <td>
                                                                     {{ item_trecho.municipio_inicio.nome }}
                                                                 </td>
                                                                 <td>
                                                                     {{ item_trecho.municipio_fim.nome }}
                                                                 </td>
                                                                 <td>
                                                                     <span v-if="item_trecho.fornecedor!==null && item_trecho.fornecedor.pessoa_juridica!==null">{{ onFormataCnpj(item_trecho.fornecedor.pessoa_juridica.cnpj_base,item_trecho.fornecedor.pessoa_juridica.cnpj_filial,item_trecho.fornecedor.pessoa_juridica.cnpj_digito)}} - {{ item_trecho.fornecedor.pessoa_juridica.razao_social }}</span>
                                                                     <span v-if="item_trecho.fornecedor!==null && item_trecho.fornecedor.pessoa_fisica!==null">{{ item_trecho.fornecedor.pessoa_fisica.nome }} - {{ item_trecho.fornecedor.pessoa_fisica.cpf }}</span>
                                                                     <span v-if="item_trecho.fornecedor!==null && item_trecho.fornecedor.pessoa_exterior!==null">{{ item_trecho.fornecedor.pessoa_exterior.nome }} - {{ item_trecho.fornecedor.pessoa_exterior.cuit }}</span>
                                                                 </td>
                                                                 <td>
                                                                      <span v-if="item_trecho.tabela_frete_rota_vig != null">{{item_trecho.tabela_frete_rota_vig.tabela_frete_rota.tabela_frete.cd}}</span>
                                                                 </td>
                                                                 <td>
                                                                      <span v-if="item_trecho.tabela_frete_rota_vig != null">{{item_trecho.tabela_frete_rota_vig.tabela_frete_rota.tabela_frete.descr}}</span>
                                                                 </td>
                                                                 <td>
                                                                   <span class="badge badge-success" v-if="item_trecho.status.valor==1">{{ item_trecho.status.descr }}</span>
                                                                   <span class="badge badge-danger" v-if="item_trecho.status.valor==2">{{ item_trecho.status.descr }}</span>
                                                                 </td>
                                                                 <td>
                                                                   <a @click="viewTabelaFrete(item_trecho.tabfrerotvig_id)" v-b-tooltip title="Informações da Tabela de frete"><i class="fa fa-info"></i></a>
                                                                   <a @click="onDetailUnidadeCargaTrechoCusto(item_trecho.peduncatr_id)" v-if="item_trecho.pedido_unidade_carga_tre_custo.length>0" v-b-tooltip title="Ver detalhes"><i class="fa fa-plus"></i></a>
                                                                 </td>
                                                             </tr>
                                                             <tr v-if="isVisibleDetailRowUCTreCusto(item_trecho.peduncatr_id)">
                                                                <td colspan="10">

                                                                  <section class="tabs-section">
                                                                  <div class="tabs-section-nav">
                                                                    <div class="tbl">
                                                                      <ul class="nav" role="tablist">
                                                                        <li class="nav-item">
                                                                          <a class="nav-link active" v-bind:href="'#t3'+item_trecho.peduncatr_id+''" role="tab" data-toggle="tab" >
                                                                            <span class="nav-link-in">
                                                                              Custos
                                                                              <i class="fa fa-bulding"></i>
                                                                            </span>
                                                                          </a>
                                                                        </li>
                                                                      </ul>
                                                                    </div>
                                                                  </div><!--.tabs-section-nav-->
                                                                  <div class="tab-content">
                                                                    <div role="tabpanel" class="tab-pane fade in active show pt-1 border-color-detalhes-grey" v-bind:id="'t3'+item_trecho.peduncatr_id+''">
                                                                      <table :class="['vuetable table table-striped tbl-typical']">
                                                                      <thead>
                                                                        <tr>
                                                                            <th style="width: 30%">Nº Custo</th>
                                                                            <th style="width: 30%">Descrição</th>
                                                                            <th style="width: 10%">Tipo Custo</th>
                                                                            <th style="width: 10%">Custo</th>
                                                                            <th style="width: 15%">Valor</th>
                                                                            <th style="width: 5%">Status</th>
                                                                        </tr>
                                                                        </thead>
                                                                        <tbody  v-for="item_tre_custo in item_trecho.pedido_unidade_carga_tre_custo">
                                                                            <tr class="bg-gray-light" style="display: table-row;">
                                                                              <td>
                                                                                  <span v-if="item_tre_custo.num_custo!==null">{{ item_tre_custo.num_custo }}</span>
                                                                              </td>
                                                                              <td>
                                                                                  <span v-if="item_tre_custo.descr!==null">{{ item_tre_custo.descr }}</span>
                                                                              </td>
                                                                              <td>
                                                                                  <span v-if="item_tre_custo.tp_custo.descr!==null">{{ item_tre_custo.tp_custo.descr }}</span>
                                                                              </td>
                                                                              <td>
                                                                                  <span v-if="item_tre_custo.custo.descr!==null">{{ item_tre_custo.custo.descr }}</span>
                                                                              </td>
                                                                              <td>
                                                                                  <span v-if="item_tre_custo.vlr_custo!==null">{{ item_tre_custo.vlr_custo }}</span>
                                                                              </td>
                                                                              <td>
                                                                                <span class="badge badge-success" v-if="item_tre_custo.status.valor==1">{{ item_tre_custo.status.descr }}</span>
                                                                                <span class="badge badge-danger" v-if="item_tre_custo.status.valor==2">{{ item_tre_custo.status.descr }}</span>
                                                                              </td>
                                                                           </tr>
                                                                         </tbody>
                                                                      </table>
                                                                    </div>
                                                                  </div>
                                                                </section>

                                                                </td>
                                                             </tr>
                                                           </tbody>
                                                        </table>
                                                      </div>
                                                    </div>
                                                  </section>
                                                </td>
                                              </tr>
                                            </template>
                                            </tbody>
                                        </table>
                                </div><!--.tab-pane-->
                        <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey" v-bind:id="'t5'+rowData.pedido_id+''">
                          <table class="table-striped" id="mais">
                              <thead>
                                  <tr>
                                      <th style="width: 50%">Responsável pelo seguro</th>
                                      <th style="width: 50%">Seguradora</th>
                                  </tr>
                               </thead>
                               <tbody>
                                   <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.pedido_param_seguro">
                                      <td>
                                          {{ item.param_tipo_resp_seg.descr }}
                                      </td>
                                      <td>
                                          {{ item.seguradora.nome }}
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                    </div><!--.tab-pane-->
			</div><!--.tab-content-->
      <PedidoTabelaFreteModal ref="pedidotabelafretemodal" />
		</div>
    </div>
  </template>

  <script>
    import PedidoTabelaFreteModal from './PedidoTabelaFreteModal.vue'
  export default {
    components:{
      PedidoTabelaFreteModal
    },
      data () {
        return {
          visibleDetailRows: [],
          carregado: false,
          teste: [],
          visibleDetailRowsPedido: [],
          visibleDetailRowsUCTreCusto: [],
          helpForm: new Form({statusRecord: [], params: [], tabfrerotvig_id: ''}),
        }
    },
    props: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },
    methods: {
      isVisibleDetailRow (rowId) {
        return this.visibleDetailRows.indexOf( rowId ) >= 0
      },
      showDetailRow (rowId) {
        if (!this.isVisibleDetailRow(rowId)) {
          this.visibleDetailRows.push(rowId)
        }
      },
      hideDetailRow (rowId) {
        if (this.isVisibleDetailRow(rowId)) {
          this.visibleDetailRows.splice(
            this.visibleDetailRows.indexOf(rowId),
            1
          )
        }
      },
      toggleDetailRow (rowId) {
        if (this.isVisibleDetailRow(rowId)) {
          this.hideDetailRow(rowId)
        } else {
          this.showDetailRow(rowId)
        }
      },
      viewTabelaFrete(tabfrerotvig_id)
      {
        this.$refs.pedidotabelafretemodal.getData(tabfrerotvig_id);   
        this.$refs.pedidotabelafretemodal.onView();   
      },
/////////////////////////////////////////////////////////////////////////////
      isVisibleDetailRowPedido (rowId) {
        return this.visibleDetailRowsPedido.indexOf( rowId ) >= 0
      },
      showDetailRowPedido (rowId) {
        if (!this.isVisibleDetailRowPedido(rowId)) {
          this.visibleDetailRowsPedido.push(rowId)
        }
      },
      hideDetailRowPedido (rowId) {
        if (this.isVisibleDetailRowPedido(rowId)) {
          this.visibleDetailRowsPedido.splice(
            this.visibleDetailRowsPedido.indexOf(rowId),
            1
          )
        }
      },
      toggleDetailRowPedido (rowId) {
        if (this.isVisibleDetailRowPedido(rowId)) {
          this.hideDetailRowPedido(rowId)
        } else {
          this.showDetailRowPedido(rowId)
        }
      },
      ////////////////////////////////////////////////
      isVisibleDetailRowUCTreCusto (rowId) {
        return this.visibleDetailRowsUCTreCusto.indexOf( rowId ) >= 0
      },
      showDetailRowUCTreCusto (rowId) {
        if (!this.isVisibleDetailRowUCTreCusto(rowId)) {
          this.visibleDetailRowsUCTreCusto.push(rowId)
        }
      },
      hideDetailRowUCTreCusto (rowId) {
        if (this.isVisibleDetailRowUCTreCusto(rowId)) {
          this.visibleDetailRowsUCTreCusto.splice(
            this.visibleDetailRowsUCTreCusto.indexOf(rowId),
            1
          )
        }
      },
      toggleDetailRowUCTreCusto (rowId) {
        if (this.isVisibleDetailRowUCTreCusto(rowId)) {
          this.hideDetailRowUCTreCusto(rowId)
        } else {
          this.showDetailRowUCTreCusto(rowId)
        }
      },
      onDetailTrecho(data) {
        this.toggleDetailRow(data.pedpartrc_id);
      },
      onDetailUnidadeCargaTrecho(pedunicar_id) {
        this.toggleDetailRowPedido(pedunicar_id);
      },
      onDetailUnidadeCargaTrechoCusto(peduncatr_id) {
        this.toggleDetailRowUCTreCusto(peduncatr_id);
      },
      onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito)
      {
          var cnpj_formatado
          var pad = "00000000"
          var cnpj_base = pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
          var pad = "0000"
          var cnpj_filial = pad.substring(0, pad.length - cnpj_filial.toString().length) + cnpj_filial;
          var pad = "00"
          var cnpj_digito = pad.substring(0, pad.length - cnpj_digito.toString().length) + cnpj_digito;

          return cnpj_base+""+cnpj_filial+""+cnpj_digito;
      },
  },
}
  </script>
